import React from 'react';
import ClipLoader from 'react-spinners/SyncLoader';

const Loader = () => (
  <div className="map-loader">
    <ClipLoader color="#4C315A" />
  </div>
);

export default Loader;
